import { Stack, Typography } from "@mui/material";
import { StepBarSection, StepDonutSection } from "../usersApiMapping";
import UsersStepBarSection from "./UsersStepBarSection";
import UsersStepDonutSection from "./UsersStepDonutSection";
import UsersStepSkel from "./UsersStepSkel";

interface UsersStepSectionsProps {
  step1Section: StepBarSection | null;
  step2Section: StepBarSection | null;
  step3Section: StepBarSection | null;
  step4Section: StepBarSection | null;
  step5Section: StepDonutSection | null;
  step6Section: StepBarSection | null;
  step7Section: StepBarSection | null;
}

const STEP_TITLES = [
  "Step 1 - Borrow Amount",
  "Step 2 - Loan Purpose",
  "Step 3 - Time in Business",
  "Step 4 - Monthly Revenue",
  "Step 5 - Business Bank Account",
  "Step 6 - Business Industry",
  "Step 7 - Personal Credit",
];

// Each step section renders as soon as ITS OWN 2-3 queries resolve, showing
// its own skeleton until then - not gated behind every other step (or the
// funnel/KPI/overview phase) being ready first. Mirrors the mobile
// UsersStepSections.tsx (which this desktop version did not previously do).
export default function UsersStepSections({
  step1Section,
  step2Section,
  step3Section,
  step4Section,
  step5Section,
  step6Section,
  step7Section,
}: UsersStepSectionsProps) {
  const sections: Array<StepBarSection | StepDonutSection | null> = [
    step1Section,
    step2Section,
    step3Section,
    step4Section,
    step5Section,
    step6Section,
    step7Section,
  ];

  return (
    <Stack spacing={4}>
      {sections.map((section, index) => (
        <Stack key={STEP_TITLES[index]} spacing={1.75}>
          <Typography sx={{ fontSize: 17, fontWeight: 500, color: "#1a1a1a" }}>
            {section?.title ?? STEP_TITLES[index]}
          </Typography>
          {!section ? (
            <UsersStepSkel donut={index === 4} />
          ) : section.kind === "bar" ? (
            <UsersStepBarSection section={section} />
          ) : (
            <UsersStepDonutSection section={section} />
          )}
        </Stack>
      ))}
    </Stack>
  );
}
